import React, { useState } from 'react'
import { Header, Input, Spacer, Button } from '@umahealth/occipital-ui/dist/compat'
import { useNavigate } from 'react-router-dom'
import { signInAnonymously, signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../config/firebase'

const LoginWithEmail = () => {
	const navigate = useNavigate()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [errorData, setErrorData] = useState(false)

	const handleSignIn = async () => {
		/* 
		Usuario de prueba: prueba@ai.com
		Contraseña de prueba: abc123456
		*/
		console.log('aaaaaaaaaaaaaaaaaaa')
		console.log(auth)
		await signInWithEmailAndPassword(auth, email, password)
			.then((res) => {
				setErrorData(false)
				console.log(res)
				navigate('/')
			})
			.catch((err) => {
				console.error(err)
				setErrorData(true)
			})
	}

	const signInAnonomous = () => {
		signInAnonymously(auth).then(res => console.log(res)).catch(err => console.error(err))
	}

	return (
		<>
			<Header type='service' />
			<div className="loginEmail">
				<h2 className="loginEmail__title">Inicia sesión</h2>
				<Spacer direction="vertical" value="1.3rem" />
				<Input
					color="secondary"
					label="Ingresa tu email"
					size="full"
					type="text"
					value={email}
					action={(e) => setEmail(e.target.value)}
				/>
				<Spacer direction="vertical" value="2.1rem" />
				<Input
					color="secondary"
					label="Ingresa tu contraseña"
					size="full"
					type="password"
					value={password}
					action={(e) => setPassword(e.target.value)}
				/>
				{
					errorData &&
					<>
						<Spacer direction="vertical" value="0.5rem" />
						<p className="loginEmail__errorMessage">Email y/o contraseña incorrecto</p>
					</>
				}
				<Spacer direction="vertical" value="2rem" />
				<Button size="full" action={() => handleSignIn()} >Ingresar</Button>
			</div>
			<Spacer direction="vertical" value="3rem" />
			<Button 
				size="full"
				type='text' 
				action={() => signInAnonomous()}>Ingresar anónimo</Button>
		</>
	)
}

export default LoginWithEmail